import isString from 'lodash/isString'
import trim from 'lodash/trim'

import config from 'config'
import { fetchWithToken } from 'utils'
import { handleStatusCodes } from './handleStatusCodes'

interface FetchItemsProps {
  selectedPbxId?: string
  filters?: string
  resource?: string
  type?: string
  path?: string
  useV5?: boolean
  lmiAccountKey?: string
  toBlob?: boolean
  toText?: boolean
  useExternalAdmin?: boolean
  acceptNotFound?: boolean
  isUsingLocationsBff?: boolean
  baseUrl?: string
  useVersion?: boolean
  handleUnauthorized?: boolean
  options?: any
}

/**
 * Retrieves all items of something
 */
const fetchItems =
  ({
    selectedPbxId,
    path,
    type,
    toBlob,
    toText,
    lmiAccountKey,
    resource,
    filters,
    useExternalAdmin,
    acceptNotFound,
    isUsingLocationsBff,
    handleUnauthorized = true,
    options,
  }: FetchItemsProps) =>
  async (): Promise<any> => {
    const pbxId = selectedPbxId
    const accountKey = lmiAccountKey
    const externalAdminUrl = config.EXTERNAL_ADMIN_URL
    const route = useExternalAdmin
      ? `ext-admin/rest/accounts/${accountKey}/${type}`
      : isString(path)
      ? trim(path)
      : isUsingLocationsBff
      ? `accounts/${accountKey}/${type}`
      : `pbxs/${pbxId}/${type}`

    return fetchWithToken({
      method: 'GET',
      baseUrl: externalAdminUrl,
      resource,
      filters: filters || '',
      path: route,
      useV5: false,
      isUsingLocationsBff,
      useVersion: '',
      handleUnauthorized,
      options,
    }).then(async (response: Response) => {
      if (
        handleStatusCodes({
          status: response.status,
          acceptNotFound,
        })
      ) {
        if (toBlob) {
          return await response.blob()
        }

        if (toText) {
          return await response.text()
        }

        return await response.json()
      }

      return false
    })
  }

export default fetchItems
